export enum MM07PartType {
    TRANSFER = 'TRANSFER',
    PULL_PUSH = 'PULL_PUSH'
}
